    <div class="mb-4">
        <div class="row mt-3">
            <div class="col-lg-9 pr-md-0">
                <div class="row">
                    <div class="col-lg-4 pr-md-0 mb-2 d-none d-lg-block">
                        <app-editor-choice-detail-profile *ngIf="profile" [profile_left_pic_image]="profile_left_pic_image"
                            [userProfileData]="userProfileData"
                            [userSpeciality]="userSpeciality"
                            [userProfile]="profile"
                            [designation]="product?.designation"
                            [activeModule]="activeModule"
                            [ecPostId]="ecPostId">
    
                        </app-editor-choice-detail-profile>
                    </div>
                    <div class="col-lg-8 ">
                        <div *ngIf="finished" class='text-center'>
                            <img class="text-center" src="assets/themes/images/primary-loader.gif" width="40"
                            id="loadmore_post" alt="loader">
                          </div>
                            <div *ngIf="errorMessage" class="bg-white container-shadow heading-4 mt-3 py-5 text-center"> 
                                <img class="mb-3" src="assets/themes/icons/restricted-content-placeholder.svg" alt="restricted-content" /><br/>
                                <span class="color-grey-500">{{errorMessage}}</span>
                            </div>
                        <app-editor-choice-detail-card
                          *ngIf="product"
                          [editorTextHighlight]="editorTextHighlight"
                          [product]="product"
                          [ec_products]="ec_products"
                          [profile]="profile"
                          [profile_pic_image]="profile_left_pic_image"
                          >
                        </app-editor-choice-detail-card>
                    </div>
                </div>
            </div>
        </div>
    </div>